<template>
  <d-modal v-if="orderKey !== null" @close="handleClose" size="lg">
    <div
      class="position-absolute w-100 d-flex justify-content-end"
      style="left: 0; top: 0;"
    >
      <d-button theme="white" style="border: none;" @click="handleOpenNewWindow" size="lg">
        <i class="material-icons text-primary">open_in_new</i>
      </d-button>
      <d-button theme="white" style="border: none;" @click="handleClose" size="lg">
        <i class="material-icons">close</i>
      </d-button>
    </div>

    <iframe
      :src="receiptLink"
      width="100%"
      :height="frameHeight"
      style="border: 0 solid rgba(0,0,0,0); background: #fff"
    ></iframe>
    <d-modal-footer>
      <d-container fluid>
        <d-row>
          <d-col cols="12" lg="6" class="my-2 my-lg-0">
            <d-input-group class="d-flex justify-content-end">
              <d-input
                :state="labelCountStatus"
                placeholder="COUNT"
                type="number"
                class="col-12 col-lg-4"
                v-model="labelCount"
              />
              <d-input-group-addon append>
                <async-button
                  @click="handlePrintLabels"
                  theme="secondary"
                  class="text-uppercase px-3"
                  :text="
                    existingLabelCount > 0 ? 'Reprint Labels' : 'Print Labels'
                  "
                  loadingText="printing..."
                  :loading="printingLabels"
                />
              </d-input-group-addon>
            </d-input-group>
          </d-col>
          <d-col cols="12" lg="3" class="my-2 my-lg-0">
            <async-button
              @click="handlePrintReceipt"
              theme="secondary"
              class="text-uppercase w-100"
              text="Reprint Receipt"
              loadingText="printing..."
              :loading="printingReceipt"
            />
          </d-col>
          <d-col cols="12" lg="3" class="my-2 my-lg-0">
            <d-button
              theme="primary"
              class="text-uppercase w-100"
              @click="handleClose"
            >
              Close
            </d-button>
          </d-col>
        </d-row>
      </d-container>
    </d-modal-footer>
    <div
      v-if="loading"
      class="bg-white position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
      style="z-index: 2000"
    >
      <odd-spinner :size="36" />
    </div>
  </d-modal>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      printingReceipt: false,
      printingLabels: false,
      receiptLink: null,
      frameHeight: null,
      labelCountStatus: null,
      labelCount: null,
      existingLabelCount: null
    };
  },
  props: {
    orderKey: {
      type: String,
      default: null
    }
  },
  watch: {
    orderKey(newValue) {
      this.resetForm();
      if (newValue !== null) {
        this.$store.dispatch("orders/get", newValue).then(order => {
          this.receiptLink = order.receipt_link;
          this.existingLabelCount = order.label_count;
          if (!!order.label_count) {
            this.labelCount = order.label_count;
          }
          setTimeout(() => {
            this.loading = false;
          }, 300);
        });
      }
    }
  },
  methods: {
    handleClose(dataUpdated = false) {
      this.$emit("close", dataUpdated);
    },
    resetForm() {
      this.loading = true;
      this.printing = false;
      this.labelCountStatus = null;
      this.labelCount = null;
      this.existingLabelCount = null;
    },
    handleWindowResize() {
      const maxHeightForScreen = (window.innerHeight - 175) * 0.95;
      const height = Math.min(maxHeightForScreen, 600);
      this.frameHeight = `${height}px`;
    },
    handlePrintLabels() {
      this.printingLabels = true;
      this.labelCountStatus = null;
      if (this.labelCount > 0) {
        const printJob = {
          orderKey: this.orderKey,
          printType: "label",
          printCount: this.labelCount
        };
        this.$store
          .dispatch("orders/printOrder", printJob)
          .then(updatedOrder => {
            this.printingLabels = false;
            this.handleClose(true);
          });
      } else {
        this.labelCountStatus = false;
        this.printing = false;
      }
    },
    handlePrintReceipt() {
      this.printingReceipt = true;
      const printJob = {
        orderKey: this.orderKey,
        printType: "receipt",
        printCount: 1
      };
      this.$store.dispatch("orders/printOrder", printJob).then(updatedOrder => {
        this.printingReceipt = false;
        this.handleClose(true);
      });
    },
    handleOpenNewWindow() {
      window.open(this.receiptLink,'_blank','directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,width=350,height=450');
    }
  },
  created() {
    window.addEventListener("resize", this.handleWindowResize);
    this.handleWindowResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
  }
};
</script>
